import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useContext, useEffect, useState } from "react";
import { FormContainer, useForm } from "react-hook-form-mui";
import { APIContext } from "../../../../Contexts/APIContext";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";
import TravelPlanV1ViewModel from "../../../ViewModels/TravelPlan/TravelPlanV1ViewModel";
import TravelPlanCarParkingV1 from "./TravelPlanCarParkingV1";
import TravelPlanCarSharingV1 from "./TravelPlanCarSharingV1";
import TravelPlanCyclingV1 from "./TravelPlanCyclingV1";
import TravelPlanFinancialV1 from "./TravelPlanFinancialV1";
import TravelPlanMainDetailsV1 from "./TravelPlanMainDetailsV1";
import TravelPlanPublicTransportV1 from "./TravelPlanPublicTransportV1";
import TravelPlanShuttleBusV1 from "./TravelPlanShuttleBusV1";
import TravelPlanSiteChangesV1 from "./TravelPlanSiteChangesV1";
import SiteViewModel from "../../../ViewModels/SiteViewModel";
import EditControl from "../../EditControl";
interface IProps {
    typeDropdown: DropDownViewModel[] | []
    groupDropdown: DropDownViewModel[] | []
    id: string
    site: SiteViewModel
}

export default function TravelPlanTabsV1({ typeDropdown, groupDropdown, id, site }: IProps) {

    const [tabVal, setTabVal] = useState(0);
    const formContext = useForm<TravelPlanV1ViewModel>({
        defaultValues: new TravelPlanV1ViewModel(),
    });
    const [readOnly, setReadOnly] = useState(true);

    const { reset } = formContext;
    const { get, post, showMessage } = useContext(APIContext);

    useEffect(() => {
        getTravelPlan();
        reset(new TravelPlanV1ViewModel)
    }, []);

    useEffect(() => {
        if (id) {
            getTravelPlan(!readOnly);
        }
    }, [readOnly]);

    const getTravelPlan = (isEdit?: boolean) => {
        get('TravelPlan', `GetTravelPlan?id=${id}&isEdit=${isEdit}`, reset)
    };

    const tabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabVal(newValue);
    };
    const submit = (form: any) => {
        post('TravelPlan', `UpdateTravelPlanV1?reference=${id}`, form, async () => {
            getTravelPlan(false)
            showMessage('success', 'Travel Plan updated successfully')
            setReadOnly(true);
        });
    }

    return (
        <>
            <Tabs value={tabVal} onChange={tabChange} >
                <Tab label="Main Details" value={0} />
                <Tab label="Site Changes" value={1} />
                <Tab label="Cycling" value={2} />
                <Tab label="Car Sharing" value={3} />
                <Tab label="Car Parking" value={4} />
                <Tab label="Financial" value={5} />
                <Tab label="Public Transport" value={6} />
                <Tab label={"Shuttle Bus"} value={8} />
            </Tabs>

            <FormContainer formContext={formContext} onSuccess={submit}>
                <EditControl readOnly={readOnly} setReadOnly={setReadOnly} />

                {tabVal == 0 && <TravelPlanMainDetailsV1 planTypes={typeDropdown} targetGroups={groupDropdown} id={id} isReadOnly={readOnly} site={site} />}
                {tabVal == 1 && <TravelPlanSiteChangesV1 isReadOnly={readOnly} />}
                {tabVal == 2 && <TravelPlanCyclingV1 isReadOnly={readOnly} />}
                {tabVal == 3 && <TravelPlanCarSharingV1 isReadOnly={readOnly} />}
                {tabVal == 4 && <TravelPlanCarParkingV1 isReadOnly={readOnly} />}
                {tabVal == 5 && <TravelPlanFinancialV1 isReadOnly={readOnly} />}
                {tabVal == 6 && <TravelPlanPublicTransportV1 isReadOnly={readOnly} />}
                {tabVal == 8 &&  <TravelPlanShuttleBusV1 isReadOnly={readOnly} />}
            </FormContainer>
        </>

    );
}
